<app-main-layout>
  <section class="flex flex-col gap-5">
    <app-leader-board />

    <app-activities />
  </section>
</app-main-layout>
